import { useTreatment } from "@splitsoftware/splitio-react";
import { useMemo } from "react";
import featureFlags from "../constants/feature-flags.json";
export var FEATURE_FLAGS = featureFlags;
export var useFeatureToggle = function(flagName) {
    var isMock = import.meta.env.MODE !== "production" || import.meta.env.VITE_MOCK;
    var _useTreatment = useTreatment({
        name: flagName
    }), isReady = _useTreatment.isReady, treatment = _useTreatment.treatment;
    return useMemo(function() {
        if (isMock) {
            return [
                true
            ];
        }
        if (!isReady) {
            return [
                undefined
            ];
        }
        return [
            treatment === "on"
        ];
    }, [
        isMock,
        isReady,
        treatment
    ]);
};

//# sourceMappingURL=useFeatureToggle.js.map